module.exports = __webpack_public_path__ + "static/media/corners1.2c7cf65e.jpg";